import React from 'react'
import { getImages } from '../Common/const'
import { Link } from 'react-router-dom'

const HomeServices = () => {
    return (
        <>
            <section className='service-wrap'>
                <div className='row gx-0'>
                    <div className='col-lg-4 col-12 wow reveal fadeInUp'>
                        <div className='service-box'>
                            <div className='sb-image'>
                                <img src={getImages('thumb-1.webp')} />
                            </div>
                            <div className='sb-bottom d-flex align-items-center justify-content-between'>
                                <div className='md-title'>View <br />Inventory</div>
                                <div>
                                    <Link to='/inventory' className='sb-white-btn d-inline-block text-start'><img src={getImages('caret-down-anticon.svg')} alt='icon' /> View</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-12 wow reveal fadeInUp'>
                        <div className='service-box'>
                            <div className='sb-image'>
                                <img src={getImages('thumb-2.webp')} />
                            </div>
                            <div className='sb-bottom d-flex align-items-center justify-content-between'>
                                <div className='md-title'>Get Your <br />Cash Offer</div>
                                <div>
                                    <Link to='/sell-your-car' className='sb-white-btn d-inline-block text-start'><img src={getImages('caret-down-anticon.svg')} alt='icon' /> View</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 col-12 wow reveal fadeInUp'>
                        <div className='service-box'>
                            <div className='sb-image'>
                                <img src={getImages('thumb-3.webp')} />
                            </div>
                            <div className='sb-bottom d-flex align-items-center justify-content-between'>
                                <div className='md-title'>Service Your <br />Mercedes</div>
                                <div>
                                    <Link to='/our-service' className='sb-white-btn d-inline-block text-start'><img src={getImages('caret-down-anticon.svg')} alt='icon' /> View</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeServices